import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import DirectStrategy from "../DirectStrategy/index.js";
export default class GateStrategy extends DirectStrategy {
  constructor(...args) {
    super(...args);
    // Specific to gate strategy vs Direct
    this.isGateOpened = false;
  }
  openGate() {
    this.isGateOpened = true;

    // Flush events that were queued
    this.notify();
  }
  closeGate() {
    this.isGateOpened = false;
  }
  notify() {
    var _superprop_getNotify = () => super.notify,
      _this = this;
    return _asyncToGenerator(function* () {
      if (!_this.isGateOpened) return;
      yield _superprop_getNotify().call(_this);
    })();
  }
}
//# sourceMappingURL=index.js.map